// The deal page selects its tab from the ?tab= query param so tabs are shareable/bookmarkable.
// This module is the single source of truth mapping the query-param slug <-> the tab label shown in the UI.

export type DealTab = "Overview" | "Deal structure" | "Due diligence";
export type DealTabSlug = "listing" | "deal-structure" | "due-diligence";

// "listing" is the default overview tab; it needs no ?tab= param (an absent/unknown param resolves to Overview).
export const DEFAULT_DEAL_TAB_SLUG: DealTabSlug = "listing";

export const DEAL_TAB_BY_SLUG: Record<DealTabSlug, DealTab> = {
  listing: "Overview",
  "deal-structure": "Deal structure",
  "due-diligence": "Due diligence",
};

export const DEAL_SLUG_BY_TAB: Record<DealTab, DealTabSlug> = {
  Overview: "listing",
  "Deal structure": "deal-structure",
  "Due diligence": "due-diligence",
};

// Falls back to the overview tab for an unknown/typo slug rather than erroring.
export const getDealTabFromSlug = (slug: string | undefined): DealTab =>
  (slug && DEAL_TAB_BY_SLUG[slug as DealTabSlug]) || "Overview";
